const utils = require('../../utils');

function isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $(document.body).addClass('is-mobile');
    }
}

function stickyHeader() {
    const thisWindow = $(window);
    thisWindow.scroll(() => {
        const scrollTop = thisWindow.scrollTop();
        const header = $('header');
        const refinementsBar = $('.refinement-bar');
        const isCheckout = $('#checkout-main').length;

        if (scrollTop > 0 && !isCheckout) {
            header.addClass('sticky');
            if (refinementsBar.length) {
                refinementsBar.addClass('header-sticky');
            }
        } else {
            header.removeClass('sticky');
            if (refinementsBar.length) {
                refinementsBar.removeClass('header-sticky');
            }
        }
    });
}

function stickyFilters(){
    const filters = $('.filters-row.sticky');
    if (filters.length === 0) return;

    let lastScrollTop = 0;
    let scrollTimer;
    const thisWindow = $(window);

    thisWindow.on('scroll', function() {
        const currentScroll = $(this).scrollTop();

        if (currentScroll > lastScrollTop) {
            filters.addClass('hidden');
        } else {
            filters.removeClass('hidden');
        }

        lastScrollTop = currentScroll;
    });
}

function infoHeaderClose() {
    const infoHeader = $('.info-container');
    const isInfoHeaderHidden = utils.getCookie('hideInfoHeader');

    if (isInfoHeaderHidden === 'true') {
        infoHeader.hide();
        $('.filters-row').addClass('no-info-header');
        $('#product-gallery .carousel').addClass('no-info-header');
    }

    infoHeader.find('.icon-cross-line').on('click', () => {
        infoHeader.addClass('d-none');
        utils.setCookie('hideInfoHeader');
        $('.filters-row').addClass('no-info-header');
        $('#product-gallery .carousel').addClass('no-info-header');
    });

    infoHeader.find('.show-more-info').on('click', (e) => {
        const thisTarget = $(e.currentTarget);
        thisTarget.toggleClass('open');
        thisTarget.parents('.info-container').toggleClass('open');
        $('.more-info').toggleClass('d-none');
    });
}

function headerAccount() {
    $('.user .icon-user-line').on('click', () => {
        const popoverBottom = $('.user .bs-popover-bottom');

        popoverBottom.toggleClass('d-none');
    });
}

function copyMenu() {
    const menuComponents = $('.main-menu');
    if (menuComponents.length > 1) {
        const origin = $(menuComponents[1]);
        const destiny = $(menuComponents[0]);
        if (origin && destiny) {
            const existsMenu = destiny.find('.navbar');
            if (!existsMenu.length) {
                const navigation = origin.find('.navbar');
                if (navigation.length) {
                    const componentToCopy = navigation.clone();
                    const destinyCopy = destiny.find('.row');
                    if (destinyCopy.length) {
                        destinyCopy.prepend(componentToCopy);
                    }
                }
            }
        }
    }
}

function showMessage(dynamicText, labelComponent, curIndex, speed, searchInput, originalContent) {
    const curVal = labelComponent.text();
    if (curVal !== originalContent) {
        labelComponent.text(curVal + dynamicText[curIndex]);
        // eslint-disable-next-line no-param-reassign
        curIndex += 1;
        if (curIndex < dynamicText.length) {
            setTimeout(() => {
                showMessage(dynamicText, labelComponent, curIndex, speed, searchInput,
                    originalContent);
            }, speed);
        }
    }
}

function loadDynamicSearchText() {
    const searchInput = $('.site-search').find('.search-field');
    if (searchInput.length) {
        const dynamicText = searchInput.attr('data-searchtext');
        const dynamicTextDate = $('#dynamicTextDate').val();

        if (dynamicText && dynamicTextDate === 'true') {
            const dynamicTextRepetitionsNumber = $('#dynamicTextRepetitionsNumber').val();
            const dynamicTextRepetitionsDelay = $('#dynamicTextRepetitionsDelay').val();
            const labelComponent = searchInput.parent().find('label');
            const originalContent = labelComponent.text();
            if (labelComponent.length) {
                const speed = 150;
                const curIndex = 0;
                let countRepetitions = 0;
                setInterval(() => {
                    const inputSearchContent = searchInput.val();
                    if (!inputSearchContent && countRepetitions < dynamicTextRepetitionsNumber) {
                        const textDisplayed = labelComponent.text();
                        if (textDisplayed === dynamicText || textDisplayed === originalContent) {
                            labelComponent.text('');
                            showMessage(dynamicText, labelComponent,
                                curIndex, speed, searchInput, originalContent);
                        }
                        // eslint-disable-next-line no-plusplus
                        countRepetitions++;
                    } else {
                        labelComponent.text(originalContent);
                    }
                },
                dynamicTextRepetitionsDelay);
            }
        }
    }
}


export default () => {
    isMobile();
    stickyHeader();
    stickyFilters();
    infoHeaderClose();
    headerAccount();
    copyMenu();
    setTimeout(() => {
        loadDynamicSearchText();
    }, 1000);
};
